import "chart.js/auto";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import TotalTransacDayPresenter from "./TotalTransacDayPresenter";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import DateRangeReport from "../../../../components/DateRangeReport";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import InitialPrompt from "../../../../components/InitialPrompt";
import CountByDayReport from "./components/CountByDayReport";
import { exportTotalTransactionsByDayCSV } from "./utils/transactionCountsByDayCsvUtils";

class TotalTransacDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalTransacDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }
  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);
        const start = startDate
          ? new Date(startDate)
          : new Date(-8640000000000000);
        const end = endDate ? new Date(endDate) : new Date();
        end.setHours(23, 59, 59, 999);
        const isDateInRange =
          (!startDate || transactionDate >= start) &&
          (!endDate || transactionDate <= end);
        const isStoreCodeMatch = selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            selectedStoreCode
          : true;

        return isDateInRange && isStoreCodeMatch;
      });
  }

  countTransactionTypesPerDayOfWeek = (transactions) => {
    const counts = {
      DineIn: new Array(7).fill(0),
      GrabFood: new Array(7).fill(0),
      TakeOut: new Array(7).fill(0),
      Delivery: new Array(7).fill(0),
      Drive: new Array(7).fill(0),
      FoodPanda: new Array(7).fill(0),
    };

    transactions
      .filter((status) => status.status === "C")
      .forEach((transaction) => {
        const dayOfWeek = new Date(transaction.tran_date).getDay();
        switch (transaction.tran_type) {
          case "D": // Dine-in
            counts.DineIn[dayOfWeek]++;
            break;
          case "G": // GrabFood
            counts.GrabFood[dayOfWeek]++;
            break;
          case "T": // Take-out
            counts.TakeOut[dayOfWeek]++;
            break;
          case "U": // Take-out
            counts.Delivery[dayOfWeek]++;
            break;
          case "K": // Take-out
            counts.Drive[dayOfWeek]++;
            break;
          case "F": // Take-out
            counts.FoodPanda[dayOfWeek]++;
            break;
          default:
            break;
        }
      });

    return counts;
  };

  getChartData() {
    const filteredTransactions = this.filterTransactions();
    const newCounts = this.countTransactionTypesPerDayOfWeek(
      filteredTransactions,
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear()
    );

    return {
      labels: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      datasets: [
        {
          label: "Dine-in",
          data: newCounts.DineIn,
          borderColor: "#1b74bb",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          fill: true,
        },
        {
          label: "GrabFood",
          data: newCounts.GrabFood,
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
          fill: true,
        },
        {
          label: "Take-out",
          data: newCounts.TakeOut,
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          fill: true,
        },
        {
          label: "Delivery",
          data: newCounts.Delivery,
          borderColor: "rgb(400, 192, 192)",
          backgroundColor: "rgba(400, 192, 192, 0.5)",
          fill: true,
        },
        {
          label: "Drive-thru",
          data: newCounts.Drive,
          borderColor: "rgb(198, 219, 86)",
          backgroundColor: "rgba(198, 219, 86, 0.5)",
          fill: true,
        },
        {
          label: "FoodPanda",
          data: newCounts.FoodPanda,
          borderColor: "#db3373",
          backgroundColor: "#db3373",
          fill: true,
        },
      ],
    };
  }

  getChartOptions() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Total Transactions vs Time of Day (Hours)",
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  }

  exportToCSV = () => {
    const { objects, storess, range } = this.state;

    const filtered = this.filterTransactions(objects);
    const transactionCounts = this.countTransactionTypesPerDayOfWeek(filtered);

    exportTotalTransactionsByDayCSV(transactionCounts, storess, range);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }
  render() {
    const { objects, storess, range } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const chartId = "chart-container8";
    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];
    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "black" }}>Total</span>
            <span style={{ color: "#83c14a" }}> Transaction</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Day of Week</span>
          </h2>
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>
        {this.state.objects && this.state.objects.length > 0 ? (
          <CountByDayReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            range={range}
            chartRef={this.chartRef8}
            containerId="chart-container8"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TotalTransacDayPage);
